import styled from 'styled-components';
import primitives from '@veneer/primitives';
import { mixins } from '@jarvis/react-portal-addons';

const Container = styled.div`
  margin-bottom: 0;
  padding: ${primitives.layout.size7}px ${primitives.layout.size4}px ${primitives.layout.size7}px;

  ${mixins.veneer.md(`
    padding: ${primitives.layout.size7}px ${primitives.layout.size7}px ${primitives.layout.size7}px;
  `)}

  ${mixins.veneer.lg(`
    padding: ${primitives.layout.size7}px ${primitives.layout.size8}px 2px;
  `)}

  ${mixins.veneer.xxl(`
    margin: 0 auto;
    max-width: 1588px;
    padding: ${primitives.layout.size7}px 36px 0;
  `)}

  button svg {
    pointer-events: none;
  }

  a {
    color: ${({ theme }) => theme.color.primary.base.default};
    text-decoration: underline;
    text-decoration-skip-ink: none;
    text-underline-offset: 25%;

    &:hover {
      color: ${({ theme }) => theme.color.primary.base.hover};
    }

    &:active {
      color: ${({ theme }) => theme.color.primary.base.active};
    }
  }
`;

export default Container;
